import { render, staticRenderFns } from "./VCompanySummary.vue?vue&type=template&id=53c7568d&scoped=true&lang=pug&v-cloak=true"
import script from "./VCompanySummary.vue?vue&type=script&lang=ts"
export * from "./VCompanySummary.vue?vue&type=script&lang=ts"
import style0 from "./VCompanySummary.vue?vue&type=style&index=0&id=53c7568d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c7568d",
  null
  
)

/* custom blocks */
import block0 from "./CompanySummary.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fpages%2FLayout%2Fviews%2FExpert%2Fviews%2FCompanies%2Ftemplate%2Fviews%2FSummary%2FVCompanySummary.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports